import { useState } from 'react';
import { School } from '@common-types';

import useHomePageStore from '@store/HomePageStore';

import ImageUpload from '@components/ImageUpload';
import ImageCrop from '@components/ImageCrop';

interface EditImageProps {
  school: School;
  showEditPhoto: boolean;
  setShowEditPhoto: (value: boolean) => void;
}

export const EditImage = (props: EditImageProps) => {
  const { school, showEditPhoto, setShowEditPhoto } = props;

  const {
    updateAdminHomePageData,
    adminHomePageData: { ipedsId },
  } = useHomePageStore((state) => state);

  const [file, setFile] = useState<globalThis.File | null>(null);
  const [isShowCrop, setIsShowCrop] = useState(false);

  const onUpdateImageHandler = async (name: string) => {
    await updateAdminHomePageData({ picture: { name } }, 'School image updated');
  };

  const onUpdatePhotoHandler = async () => {
    setShowEditPhoto(true);
  };

  return (
    <>
      <ImageUpload
        isOpen={showEditPhoto}
        onClose={() => setShowEditPhoto(false)}
        onImageUpload={(file) => {
          setFile(file);
          setIsShowCrop(true);
        }}
      />
      {isShowCrop && school ? (
        <ImageCrop
          filename={`${ipedsId}`}
          folder={`${ipedsId}`}
          school={school}
          file={file}
          onClose={() => setIsShowCrop(false)}
          onSelectImage={onUpdatePhotoHandler}
          onSaveImage={onUpdateImageHandler}
        />
      ) : null}
    </>
  );
};
